export class EmployeeDeduction {
  Id: string;
  IsActive: boolean;

  // deduction entries
  LoanBalance: number; // read-only
  Rates: EmployeeDeductionRate[];
  DisposableLimitType: string;
  DisposableLimit: number;
  AnnualLimit: number;
  LoanId: string;
  SelectedThirdPartyPayee: number;
  CaseNumber: string;
  EmployerOffersFamilyMedIns: boolean;
  IntegrityHash: string;
}

export class EmployeeDeductionRate {
  SequenceNumber: number;
  EffectiveDate: Date | string;
  LastChangedOn: Date;
  LastEditorId: string;
  Amount: number;
  IntegrityHash: string;
}

export class EmployeeHealthDeduction extends EmployeeDeduction {
  HealthAmount: number;
}

export class EmployeeLoanDeduction extends EmployeeDeduction {
  LoanLimit: number;
  LoanAmount: number;
}
